import { datareadStore, datasetStore } from '../managers/globalState';
import globalRefs from '../managers/globalRefs';
import * as Pioneer from 'pioneer';
import { hideLoading, showLoading } from '../components/loading';

let isDrawing = false;
let startScreen = null;
let rectangleDiv = null;
let _pickController = null;
let _position = null
let collectedData = [];
let gridOverlayContainer = null;
let persistentGridDataVisible = false;
let isSelectionActive = false;
let clickBlockerOverlay = null;
let fixedGridSnapshot = null;
let hasDownloadedSelection = false;

function blockSelectionNavigation(event) {
  if (!datareadStore.stateSnapshot.hasSelectedRegion) return;
  if (event.type === 'keydown' && event.key === 'Tab') return;
  if (event.target.closest?.('#export_select, #cancel_select')) return;
  // Export triggers a separate click on its temporary CSV link.
  if (event.type === 'click' &&
      event.target.id === 'region_csv_download' &&
      event.target.getAttribute?.('download') === 'region_data.csv' &&
      event.target.href?.startsWith('blob:')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (hasDownloadedSelection && (event.type === 'click' ||
      (event.type === 'keydown' && !event.repeat && ['Enter', ' '].includes(event.key)))) {
    alert('لا يمكنك الانتقال إلى علامة حيوية أو تبويب آخر حتى تضغط على إلغاء.');
  }
}

function enableClickBlocker() {
  // Capture events before React navigation handlers, regardless of stacking order.
  for (const type of ['click', 'pointerdown', 'mousedown', 'touchstart', 'keydown']) {
    window.addEventListener(type, blockSelectionNavigation, { capture: true, passive: false });
  }
  if (clickBlockerOverlay) return;

  clickBlockerOverlay = document.createElement('div');
  clickBlockerOverlay.id = 'click-blocker-overlay';
  document.body.style.overflow = 'hidden';
  Object.assign(clickBlockerOverlay.style, {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0)',
    zIndex: '100000', // Make sure it's above all UI
    pointerEvents: 'auto'
  });

  document.body.style.pointerEvents = 'none';

  document.body.appendChild(clickBlockerOverlay);
}

function disableClickBlocker() {
  for (const type of ['click', 'pointerdown', 'mousedown', 'touchstart', 'keydown']) {
    window.removeEventListener(type, blockSelectionNavigation, true);
  }
  if (clickBlockerOverlay) {
    clickBlockerOverlay.remove();
    clickBlockerOverlay = null;
    document.body.style.overflow = '';
  }

  document.body.style.pointerEvents = 'auto';
}

function onMouseMove(event) {
  event.preventDefault();
  if (!isDrawing || !rectangleDiv) return;

  const endX = event.clientX;
  const endY = event.clientY;

  const {pioneer} = globalRefs;
  const { x: cx, y: cy, r } = getGlobeScreenBounds(pioneer);

  // Clamp end point to stay within circular bounds
  const dx = endX - cx;
  const dy = endY - cy;
  const dist = Math.sqrt(dx * dx + dy * dy);

  let clampedX = endX;
  let clampedY = endY;

  if (dist > r) {
    const scale = r / dist;
    clampedX = cx + dx * scale;
    clampedY = cy + dy * scale;
  }

  const left = Math.min(startScreen.x, clampedX);
  const top = Math.min(startScreen.y, clampedY);
  const width = Math.abs(clampedX - startScreen.x);
  const height = Math.abs(clampedY - startScreen.y);

  Object.assign(rectangleDiv.style, {
    left: `${left}px`,
    top: `${top}px`,
    width: `${width}px`,
    height: `${height}px`
  });

  const insideX = event.clientX >= Math.min(startScreen.x, clampedX) && event.clientX <= Math.max(startScreen.x, clampedX);
  const insideY = event.clientY >= Math.min(startScreen.y, clampedY) && event.clientY <= Math.max(startScreen.y, clampedY);
  datareadStore.setGlobalState({ isCursorInsideSelection: insideX && insideY });
  
}

function onMouseDown(event) {
  // Controls remain usable above the blocker and must not start a new drag.
  if (event.target.closest('.rectangle-button-container')) return;
  if (isDrawing) return;
  event.preventDefault();
  if (!datareadStore.state.isSelectingRegion) return;

  const {pioneer} = globalRefs;
  disableCameraControls(pioneer);
  
  const { x: cx, y: cy, r } = getGlobeScreenBounds();

  let startX = event.clientX;
  let startY = event.clientY;

  const dx = startX - cx;
  const dy = startY - cy;
  const dist = Math.sqrt(dx * dx + dy * dy);
  if (dist > r) {
    // Clamp start to circle edge
    const scale = r / dist;
    startX = cx + dx * scale;
    startY = cy + dy * scale;
  }
  startScreen = { x: startX, y: startY };
  isDrawing = true;
  isSelectionActive = true;
  enableClickBlocker();
  rectangleDiv = document.createElement('div');
  rectangleDiv.style.position = 'absolute';
  rectangleDiv.style.border = '4px solid #2a5e96';
  rectangleDiv.style.backgroundColor = 'rgba(0, 0, 255, 0.1)';
  rectangleDiv.style.pointerEvents = 'none';
  rectangleDiv.id = 'selection-rect';
  document.body.appendChild(rectangleDiv);
  

}

function onMouseUp(event) {
const {pioneer} = globalRefs;

if (!isDrawing) return;
isDrawing = false;
isSelectionActive = true;
enableClickBlocker();
document.body.style.overflow = '';
//unlock globe
//enableCameraControls(pioneer); 

let endX = event.clientX;
let endY = event.clientY;
const { x: cx, y: cy, r } = getGlobeScreenBounds();
const dx = endX - cx;
const dy = endY - cy;
const dist = Math.sqrt(dx * dx + dy * dy);
showLoading('event');

if (dist > r) {
  // Clamp start to circle edge
  const scale = r / dist;
  endX = cx + dx * scale;
  endY = cy + dy * scale;
}

const startNorm = { x: startScreen.x / window.innerWidth, y: startScreen.y / window.innerHeight };
const endNorm = { x: endX / window.innerWidth, y: endY / window.innerHeight };
const region = { startNorm, endNorm };

const endScreen = { x: endX, y: endY};
//const region = {startScreen, endScreen };

console.log("Extracting from screen region:", region);
  
  datareadStore.setGlobalState({
    selectedRegion: region,
    isSelectingRegion: false,
    hasSelectedRegion: true
  });

  const startX = startNorm.x * window.innerWidth;
  const startY = startNorm.y * window.innerHeight;
  const realEndX = endNorm.x * window.innerWidth;
  const realEndY = endNorm.y * window.innerHeight;

  extractDataFromRegion({ 
    startScreen: { x: startX, y: startY }, 
    endScreen: { x: realEndX, y: realEndY } 
  });
  hideLoading('event');
  
  // if (rectangleDiv) {
  //   rectangleDiv.remove();
  //   rectangleDiv = null;
  // }
  showPersistentGrid(startX, startY, realEndX, realEndY);
  persistentGridDataVisible = true;
  
  document.removeEventListener('mousedown', onMouseDown);
  document.removeEventListener('mousemove', onMouseMove);
  document.removeEventListener('mouseup', onMouseUp);

}

// Responsive resize handler
window.addEventListener('resize', () => {
  const region = datareadStore.stateSnapshot.selectedRegion;
  if (!region || !rectangleDiv || !persistentGridDataVisible || !fixedGridSnapshot) return;

  const startX = region.startNorm.x * window.innerWidth;
  const startY = region.startNorm.y * window.innerHeight;
  const endX = region.endNorm.x * window.innerWidth;
  const endY = region.endNorm.y * window.innerHeight;

  Object.assign(rectangleDiv.style, {
    left: `${Math.min(startX, endX)}px`,
    top: `${Math.min(startY, endY)}px`,
    width: `${Math.abs(endX - startX)}px`,
    height: `${Math.abs(endY - startY)}px`
  });

  // Restore frozen grid overlay
  if (gridOverlayContainer) gridOverlayContainer.remove();
  gridOverlayContainer = document.createElement('div');
  gridOverlayContainer.style.position = 'absolute';
  gridOverlayContainer.style.left = '0';
  gridOverlayContainer.style.top = '0';
  gridOverlayContainer.style.width = '100%';
  gridOverlayContainer.style.height = '100%';
  gridOverlayContainer.style.pointerEvents = 'none';
  gridOverlayContainer.style.zIndex = 9999;
  rectangleDiv.parentElement?.appendChild(gridOverlayContainer);

  fixedGridSnapshot.forEach(({ div, normalized }) => {
    const width = normalized.width * window.innerWidth;
    const height = normalized.height * window.innerHeight;
    const fontSize = Math.min(width, height) * 0.4;
    Object.assign(div.style, {
      left: `${normalized.left * window.innerWidth}px`,
      top: `${normalized.top * window.innerHeight}px`,
      width: `${width}px`,
      height: `${height}px`,
      fontSize: `${fontSize}px`
    });
    gridOverlayContainer.appendChild(div);
  });
});

export function startRectangleSelection() {
    hasDownloadedSelection = false;
    const {pioneer} = globalRefs;
    document.body.style.overflow = 'hidden'; 
    //lock globe
    disableCameraControls(pioneer); 

    datareadStore.setGlobalState({ isSelectingRegion: true });
  
    document.addEventListener('mousedown', onMouseDown);
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
   

}

export function cancelRectangleSelection() {
  hasDownloadedSelection = false;
  const { pioneer } = globalRefs;
  isDrawing = false;
  startScreen = null;
  collectedData = [];
  fixedGridSnapshot = null;
  isSelectionActive = false;
  disableClickBlocker(); //unblock all clicks
  document.body.style.overflow = ''; 
  enableCameraControls(pioneer);
  // datareadStore.setGlobalState({ isSelectingRegion: false });

  datareadStore.setGlobalState({
    isSelectingRegion: false,
    hasSelectedRegion: false,
    selectedRegion: null,
    regionData: []
  });

  if (rectangleDiv) {
    rectangleDiv.remove();
    rectangleDiv = null;
  }

  if (gridOverlayContainer) {
    gridOverlayContainer.remove();
    gridOverlayContainer = null;
    persistentGridDataVisible = false;
  }
  datareadStore.setGlobalState({ isCursorInsideSelection: false });
  
  document.removeEventListener('mousedown', onMouseDown);
  document.removeEventListener('mousemove', onMouseMove);
  document.removeEventListener('mouseup', onMouseUp);
}

export function completeRectangleExport() {
  hasDownloadedSelection = true;
  // Keep the selection, frozen camera, and navigation blocker until Cancel.
}

export function clearSelectedRegionData() {
  datareadStore.setGlobalState({ regionData: [] });
  collectedData = [];
  fixedGridSnapshot = null;
  if (gridOverlayContainer) {
    gridOverlayContainer.remove();
    gridOverlayContainer = null;
  }
}

export function refreshSelectedRegionData() {
  const { selectedRegion, hasSelectedRegion } = datareadStore.stateSnapshot;
  if (!hasSelectedRegion || !selectedRegion || !rectangleDiv) return;
  clearSelectedRegionData();
  if (!datasetStore.stateSnapshot.currentDataset?.readoutData) return;

  const startScreen = {
    x: selectedRegion.startNorm.x * window.innerWidth,
    y: selectedRegion.startNorm.y * window.innerHeight
  };
  const endScreen = {
    x: selectedRegion.endNorm.x * window.innerWidth,
    y: selectedRegion.endNorm.y * window.innerHeight
  };
  extractDataFromRegion({ startScreen, endScreen });
  showPersistentGrid(startScreen.x, startScreen.y, endScreen.x, endScreen.y);
}

function positionToLatLon(position) {
  const {pioneer} = globalRefs;
  const earth = pioneer.get('main').getEntity('earth');
  let lla = new Pioneer.LatLonAlt();


  try {
    let positionInFrame = new Pioneer.Vector3
    positionInFrame.rotateInverse(earth.getOrientation(), position);
    earth.getComponent(Pioneer.SpheroidComponent).llaFromXYZ(lla, positionInFrame);

    const lat = Pioneer.MathUtils.radToDeg(lla.lat);
    const lon = Pioneer.MathUtils.radToDeg(lla.lon);
    return { lat, lon };
  } catch (e) {
    return null;
  } 
}

function extractDataFromRegion(region) {
  const { getManager } = globalRefs;
  const {  currentDataset } = datasetStore.stateSnapshot;
  const cameraManager = getManager('camera');
  const isCelcius = datareadStore.stateSnapshot.isCelcius;
	const { readoutData, externalId } = currentDataset || {};

  collectedData = [];

  const { startScreen, endScreen } = region;
  //you can also draw a rectangle by moving to the left so handle for that

  const datasetTitle = currentDataset?.title || 'Unknown Dataset';
  const tileManager = getManager('dataset').tileManager;
  const isTileDataset = Boolean(tileManager && !tileManager.isCubemap);

  const x1 = Math.min(startScreen.x, endScreen.x);
  const x2 = Math.max(startScreen.x, endScreen.x);
  const y1 = Math.min(startScreen.y, endScreen.y);
  const y2 = Math.max(startScreen.y, endScreen.y);
  const width = x2 - x1;
  const height = y2 - y1;
  const maxSamples = 4000; // cap total work for tile datasets
  const step = Math.max(1, Math.sqrt((width * height) / maxSamples));

  const processPoint = (x, y) => {
    try {
      const position = convertPixelSpaceToEntitySpace(x,y)
      let result;

      if(isTileDataset) {
        const lat_lon = positionToLatLon(position);
        const possibleTileManager = getManager('dataset').tileManager;
        const c = possibleTileManager.calculateColorFromRaycasting(new Pioneer.Vector2(x,y))
        let value = possibleTileManager.calculateDataFromColor(c)
        if (!Number.isFinite(value) || !lat_lon) return;
       // const lat_lon = positionToLatLon(position)
        
        let dataUnits = readoutData.units;
        if (dataUnits === 'م°' && !isCelcius) {
          dataUnits = 'ف°';
          value = value * 1.8 + 32;
        } else if (dataUnits === 'ف°' && isCelcius) {
          dataUnits = 'م°';
          value = (value - 32) / 1.8;
        }
        result = {
          value: value.toFixed(1),
          units: dataUnits,
          lat:`${Math.abs(lat_lon.lat).toFixed(2)} ° ${lat_lon.lat > 0 ? 'N' : 'S'}`,
          lon: `${Math.abs(lat_lon.lon).toFixed(2)} ° ${lat_lon.lon > 0 ? 'E' : 'W'}`,
          dataset: datasetTitle
        };
      } else {
        result = cameraManager._calcDataFromPosition(position, true);
      }
      if (result && result.value !== 'NaN' && !isNaN(result.value)) {
        collectedData.push({
          ...result,
          dataset: datasetTitle
        });
      }
    } catch (e) {
      console.error(`Error simulating pick at (${x}, ${y}):`, e);
    }
  };

  if (isTileDataset) {
    for (let x = x1; x < x2; x += step) {
      for (let y = y1; y < y2; y += step) {
        processPoint(x, y);
      }
    }
  } else {
    for (let x = x1; x < x2; x++) {
      for (let y = y1; y < y2; y++) {
        processPoint(x, y);
      }
    }
  }
    console.log('Extracted', collectedData.length, 'values');
    datareadStore.setGlobalState({ regionData: collectedData });
}

function showPersistentGrid(startX, startY, endX, endY) {
  const { getManager } = globalRefs;
  const { currentDataset } = datasetStore.stateSnapshot;
  const cameraManager = getManager('camera');
  const isCelcius = datareadStore.stateSnapshot.isCelcius;
	const { readoutData, externalId } = currentDataset || {};
  const tileManager = getManager('dataset').tileManager;
  const isTileDataset = Boolean(tileManager && !tileManager.isCubemap);

  if (gridOverlayContainer) gridOverlayContainer.remove();

  gridOverlayContainer = document.createElement('div');
  gridOverlayContainer.style.position = 'absolute';
  gridOverlayContainer.style.left = '0';
  gridOverlayContainer.style.top = '0';
  gridOverlayContainer.style.width = '100%';
  gridOverlayContainer.style.height = '100%';
  gridOverlayContainer.style.pointerEvents = 'none';
  gridOverlayContainer.style.zIndex = 9999;

  rectangleDiv.parentElement?.appendChild(gridOverlayContainer);

  const left = Math.min(startX, endX);
  const right = Math.max(startX, endX);
  const top = Math.min(startY, endY);
  const bottom = Math.max(startY, endY);

  const selectionWidth = right - left;
  const selectionHeight = bottom - top;
  const area = selectionWidth * selectionHeight;

  const minGrids = 4;
  const maxGrids = 200;

  let gridCount = Math.floor(minGrids + (maxGrids - minGrids) * (area / 250000));
  gridCount = Math.max(minGrids, Math.min(gridCount, maxGrids));

  const aspectRatio = selectionWidth / selectionHeight;
  const cols = Math.max(1, Math.ceil(Math.sqrt(gridCount * aspectRatio)));
  const rows = Math.max(1, Math.ceil(gridCount / cols));

  const gridWidth = selectionWidth / cols;
  const gridHeight = selectionHeight / rows;

  fixedGridSnapshot = [];

for (let col = 0; col < cols; col++) {
  for (let row = 0; row < rows; row++) {
    const gridLeft = left + col * gridWidth;
      const gridTop = top + row * gridHeight;
      const centerX = gridLeft + gridWidth / 2;
      const centerY = gridTop + gridHeight / 2;

    try {
      const position = convertPixelSpaceToEntitySpace(centerX, centerY);
      const latlon = positionToLatLon(position);

      let value;
      if (isTileDataset) {
        const possibleTileManager = getManager('dataset').tileManager;

        const c = possibleTileManager.calculateColorFromRaycasting(new Pioneer.Vector2(centerX, centerY));
        value = possibleTileManager.calculateDataFromColor(c);
      } else {
        const result = cameraManager._calcDataFromPosition(position, true);
        value = result?.value;
      }

      if (value !== undefined && !isNaN(value)) {
        const fontSize = Math.min(gridWidth, gridHeight) * 0.4;
        const div = document.createElement('div');
        div.textContent = Number(value).toFixed(1);
        // const decimalPlace = 2;
        // const valStr = Number(value).toFixed(1);
        // let dataUnits = readoutData.units;
        // if (dataUnits === 'م°' && !isCelcius) {
        //   dataUnits = 'ف°';
        //   value = value * 1.8 + 32;
        // } else if (dataUnits === 'ف°' && isCelcius) {
        //   dataUnits = 'م°';
        //   value = (value - 32) / 1.8;
        // }
        // const unitStr = dataUnits;
        // const latStr = `${Math.abs(latlon.lat).toFixed(decimalPlace)}° ${latlon.lat >= 0 ? 'N' : 'S'}`;
        // const lonStr = `${Math.abs(latlon.lon).toFixed(decimalPlace)}° ${latlon.lon >= 0 ? 'E' : 'W'}`;

        // div.innerHTML = `<div style="line-height:1.2">${valStr} ${unitStr}<br/></div>`;
        Object.assign(div.style, {
          position: 'absolute',
          left: `${gridLeft}px`,
          top: `${gridTop}px`,
          width: `${gridWidth}px`,
          height: `${gridHeight}px`,
          border: '1px solid rgba(255,255,255,0.3)',
          boxSizing: 'border-box',
          color: 'white',
          //fontSize: `${Math.min(gridWidth, gridHeight) * 0.3}px`,
          fontSize: `${fontSize}px`,
          lineHeight: '1.1',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          pointerEvents: 'none',
          overflow: 'hidden'
        });
        gridOverlayContainer.appendChild(div);
        fixedGridSnapshot.push({
          div: div.cloneNode(true),
          normalized: {
            left: gridLeft / window.innerWidth,
            top: gridTop / window.innerHeight,
            width: gridWidth / window.innerWidth,
            height: gridHeight / window.innerHeight
          }
        });
      }
    } catch (e) {
      console.warn(`Grid error at (${centerX}, ${centerY}):`, e);
    }
  }
}
// fixedGridSnapshot = Array.from(gridOverlayContainer.children).map(child => {
//   return {
//     div: child.cloneNode(true),
//     normalized: {
//       left: parseFloat(child.style.left) / window.innerWidth,
//       top: parseFloat(child.style.top) / window.innerHeight,
//       width: parseFloat(child.style.width) / window.innerWidth,
//       height: parseFloat(child.style.height) / window.innerHeight
//     }
//   };
// });
}

function convertPixelSpaceToEntitySpace(x,y){
  // console.log("convertPixelSpaceToEntitySpace", {x,y})
  const { pioneer } = globalRefs;
  const cameraEntity = pioneer.get('main').getEntity('camera') //maybe better ways of grabbing that?
  const cameraComponent = cameraEntity.getComponent(Pioneer.CameraComponent);

  let position = new Pioneer.Vector3();
  //get position in normal space
  let normalSpacePosition = new Pioneer.Vector3();
  const xyPos = new Pioneer.Vector2(x,y)  //maybe just {x,y}
  cameraComponent.getViewport().getNormalSpacePositionFromPixelSpacePosition(normalSpacePosition, xyPos);
  
  //get position in camera space
  cameraComponent.getCameraSpacePositionFromNormalSpacePosition(position, normalSpacePosition);

  //convert position to entity space

  // Turn it into a ray of length 1, going from the camera.
  position.normalize(position);

  let interval = new Pioneer.Interval();
  const earth = pioneer.get('main').getEntity('earth');
  const spheroid = earth.getComponent(Pioneer.SpheroidComponent)

  // We scale up the ray and entity position and rotate them into the picked entity's orientation frame.
  const ratio = spheroid.getEquatorialRadius() / spheroid.getPolarRadius();
  position.rotateInverse(earth.getOrientation(), position);
  position.z *= ratio;
  let entityPosition = new Pioneer.Vector3();
  entityPosition.copy(earth.getCameraSpacePosition(cameraComponent));
  entityPosition.rotateInverse(earth.getOrientation(), entityPosition);
  entityPosition.z *= ratio;
  Pioneer.Geometry.getLineSphereIntersectionWithLineStartAtOrigin(interval, position, entityPosition, spheroid.getEquatorialRadius());
  position.z /= ratio;
  position.rotate(earth.getOrientation(), position);
  if (!Number.isNaN(interval.min)) {
    // Convert the picked position from camera space to entity space.
    position.mult(position, interval.min);
    cameraEntity.getPositionRelativeToEntity(position, position, earth);

  }

  return position
}

  function disableCameraControls(pioneer) {
    console.log("disableCameraControls")
    const cameraEntity = pioneer.get('main').getEntity('camera')
    const orbit = cameraEntity.getController(Pioneer.OrbitController);
    const zoom = cameraEntity.getController(Pioneer.ZoomController);

    orbit?.setEnabled(false);
    zoom?.setEnabled(false);
  }
  
  function enableCameraControls(pioneer) {
    const cameraEntity = pioneer.get('main').getEntity('camera')
    const orbit = cameraEntity.getController(Pioneer.OrbitController);
    const zoom = cameraEntity.getController(Pioneer.ZoomController);
  
    orbit?.setEnabled(true);
    zoom?.setEnabled(true);
  }

function getGlobeScreenBounds() {
  const cx = window.innerWidth / 2;
  const cy = window.innerHeight / 2;

  // Assume globe's projected radius is ~42% of screen height
  const r = window.innerHeight * 0.42;

  return { x: cx, y: cy, r };
}


export function setPickController() {
  const { pioneer, getManager } = globalRefs;
  const cameraEntity = pioneer.get('main').getEntity('camera');
  const earth = pioneer.get('main').getEntity('earth');
  _pickController = cameraEntity.getController(Pioneer.PickController) ?? cameraEntity.addController(Pioneer.PickController);
  _pickController.setPickedEntity(earth);
  _pickController.setTriggerOnHover(true);
  _pickController.setCallback(position => {
    _position = position
  })
  

  // _pickController.setCallback(position => {
  //   console.log("pc callback: ", position)
  //   const result = cameraManager._calcDataFromPosition(position, true);
  //   if (result && result.value !== 'NaN' && !isNaN(result.value)) {
  //     collectedData.push({
  //       value: result.value,
  //       units: result.units,
  //       lat: result.lat,
  //       lon: result.lon
  //     });
  //   }
  // });

  console.log("Pick controller and callback initialized");
}
